import Endpoints from "../constants/Endpoints";
import {RestRequestGET, RestRequestPOST} from "../libs/RestRequest";
import isResponseValid from "../libs/isResponseValid";
import reduxStore from "../redux/store";
import {setSaveStatusError} from "../redux/actions";
import Tr from "../translations/Translations";

const showError = (message) => {
    reduxStore.dispatch(setSaveStatusError(message))
}

const getAuthorizationStatus = async () => {
    try {
        const resp = await RestRequestGET(Endpoints.EZAMOWIENIA_AUTHORIZATION_STATUS);
        if (isResponseValid(resp, showError)) {
            return resp.result;
        }
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
}
const revokeToken = async () => {
    try {
        const resp = await RestRequestPOST(Endpoints.EZAMOWIENIA_REVOKE_TOKEN);
        isResponseValid(resp, showError)
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
}

export default {
    getAuthorizationStatus,
    revokeToken
};

